module.exports = {
  cookie_1: 'This website uses cookies to personalise your experience. Details are described in our',
  cookie_2: 'By using our website and agreeing to this policy, you consent to our use of cookies',
  cookiePrivacy: 'Privacy and Cookies Policy',
  tearmsConditions: 'Terms & Conditions',
  accept: 'I Accept',
  register: 'Register',
  login: 'Log In',
  logout: 'Log Out',
  history: 'History',
  settings: 'Settings',
  notActive: 'Dear customer, this webshop is not currently active.',
  failLogOut: 'Failed to log out',
  logOut: 'You are now logged out',
  iAgree1: 'I hereby agree to the',
  iAgree2: '',
  and: 'and',
  adminPanel: 'Admin Panel',
  besuche: 'Visits',
  rateUs: 'Please rate us',
  rateHint: 'Please let us know what you think',
  orders: 'Orders',
  customer: 'Customer',
  deliveryTime: 'Delivery time',
  type: 'Type',
  rating: 'Rating',
  value: 'Value',
};



// WEBPACK FOOTER //
// ./src/lang/en/header.js